 // src/components/Skills/Skills.js
// import React from 'react';
// import './Skills.css';

// const Skills = () => {


//   const skills = [
//   { name: 'React JS', icon: 'fab fa-react', level: 95 },
//   { name: 'React Native', icon: 'fab fa-react', level: 95 },
//   { name: 'JavaScript / TypeScript', icon: 'fab fa-js', level: 90 },

//   { name: 'Next.js', icon: 'fas fa-layer-group', level: 85 },
//   { name: 'Redux / Context API', icon: 'fas fa-project-diagram', level: 88 },

//   { name: 'iOS Development', icon: 'fab fa-apple', level: 85 },
//   { name: 'Android Development', icon: 'fab fa-android', level: 85 },

//   { name: 'REST API Integration', icon: 'fas fa-code', level: 90 },
//   { name: 'Third-Party SDKs', icon: 'fas fa-plug', level: 88 },

//   { name: 'Firebase', icon: 'fas fa-fire', level: 85 },
//   { name: 'CI/CD & App Deployment', icon: 'fas fa-rocket', level: 80 },

//   { name: 'UI/UX & Figma to Code', icon: 'fas fa-paint-brush', level: 85 },
//   { name: 'Responsive Web Design', icon: 'fas fa-mobile-alt', level: 90 },

//   { name: 'Git & GitHub', icon: 'fab fa-github', level: 90 }
// ];


//   return (
//     <section id="skills" className="skills">
//       <div className="container">
//         <h2 className="section-title">My Skills</h2>
//         <div className="skills-container">
//           {skills.map((skill, index) => (
//             <div key={index} className="skill-card">
//               <div className="skill-icon">
//                 <i className={skill.icon}></i>
//               </div>
//               <h3>{skill.name}</h3>
//               <div className="skill-progress">
//                 <div className="progress-bar">
//                   <div 
//                     className="progress-fill" 
//                     style={{ width: `${skill.level}%` }}
//                   ></div>
//                 </div>
//                 <span>{skill.level}%</span>
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>
//     </section>
//   );
// };

// export default Skills;



// src/components/Skills/Skills.js
import React from 'react';
import { 
  Code2, Smartphone, Globe, Database, Palette, 
  Cloud, Zap, GitBranch, Shield, Cpu, Layers,
  Server, Terminal, Eye, SmartphoneCharging,
  Wifi, Cpu as Chip, Grid, PieChart,
  CloudLightning, DatabaseZap, PenTool,
  MonitorSmartphone, CloudUpload
} from 'lucide-react';
import './Skills.css';

const Skills = () => {
  const skillCategories = [
    {
      title: 'Frontend Development',
      icon: <Code2 size={24} />,
      color: '#6366f1',
      skills: [
        { name: 'React.js', level: 95, icon: '⚛️' },
        { name: 'Next.js', level: 90, icon: '▲' },
        {name: 'Vue.js', level:90, icon:'⚡'},
        { name: 'TypeScript', level: 88, icon: '📘' },
        { name: 'JavaScript (ES6+)', level: 95, icon: '🟨' },
        { name: 'HTML5', level: 98, icon: '📄' },
        { name: 'CSS3', level: 95, icon: '🎨' },
      ]
    },
    {
      title: 'Mobile Development',
      icon: <Smartphone size={24} />,
      color: '#10b981',
      skills: [
        { name: 'React Native CLI', level: 100, icon: '📱' },
        { name: 'Expo', level: 100, icon: '⚡' },
        { name: 'iOS Development', level: 100, icon: '🍎' },
        { name: 'Android Development', level: 100, icon: '🤖' },
        { name: 'Cross-Platform', level: 100, icon: '🔄' },
        { name: 'Mobile UI/UX', level: 95, icon: '📐' },
      ]
    },
    {
      title: 'State & Data Management',
      icon: <Database size={24} />,
      color: '#8b5cf6',
      skills: [
        { name: 'Redux Toolkit', level: 90, icon: '🔄' },
        // { name: 'TanStack Query', level: 88, icon: '⚡' },
        { name: 'Context API', level: 92, icon: '📦' },
        // { name: 'Zustand', level: 85, icon: '🐻' },
        // { name: 'MobX', level: 80, icon: '⚡' },
        // { name: 'GraphQL/Apollo', level: 82, icon: '📊' },
      ]
    },
    {
      title: 'Backend & APIs',
      icon: <Server size={24} />,
      color: '#f59e0b',
      skills: [
        { name: 'Node.js', level: 85, icon: '🟢' },
        { name: 'Express.js', level: 82, icon: '🚂' },
        { name: 'REST APIs', level: 92, icon: '🔗' },
        { name: 'WebSockets', level: 80, icon: '⚡' },
        { name: 'Firebase', level: 88, icon: '🔥' },
        { name: 'MongoDB', level: 80, icon: '🍃' },
      ]
    },
    {
      title: 'UI/UX & Styling',
      icon: <Palette size={24} />,
      color: '#ec4899',
      skills: [
        { name: 'Tailwind CSS', level: 94, icon: '🎨' },
        { name: 'Styled Components', level: 90, icon: '💅' },
        { name: 'Material-UI', level: 85, icon: '🎭' },
        { name: 'Bootstrap', level: 88, icon: '🎪' },
        { name: 'Figma to Code', level: 90, icon: '🎯' },
        { name: 'Responsive Design', level: 96, icon: '📱' },
      ]
    },
    {
      title: 'Tools & DevOps',
      icon: <Terminal size={24} />,
      color: '#06b6d4',
      skills: [
        { name: 'Git & GitHub', level: 95, icon: '🐙' },
        { name: 'CI/CD', level: 85, icon: '🔄' },
        { name: 'Firebase', level: 75, icon: '🐳' },
        { name: 'Git/Github', level: 78, icon: '☁️' },
        { name: 'VS Code', level: 97, icon: '💻' },
        { name: 'Testing', level: 82, icon: '🧪' },
      ]
    },
  ];

  const allSkills = [
    // Frontend
    'React', 'Next.js', 'Vue.js', 'TypeScript', 'JavaScript', 'HTML5', 'CSS3', 'Vue.js', 'Angular',
    // Mobile
    'React Native', 'Expo', 'XCode', 'Android Studio',
    // State Management
    'Redux',  'Context API', 
    // Backend
    'Node.js', 'Express', 'Python', 'Firebase', 'MongoDB',
    // Styling
    'Tailwind CSS', 'Styled Components', 'Material-UI', 'Bootstrap', 'CSS Modules',
    // Tools
    'Git', 'GitHub',  'VS Code', 'Figma', 
    // Libraries
    'Axios', 'React Router', 'Formik', 'React Hook Form', 'Socket.io',
  ];

  return (
    <section id="skills" className="skills-section">
      <div className="container">
        <div className="section-header">
          <span className="section-subtitle">My Expertise</span>
          <h2 className="section-title">Technical Skills & Proficiencies</h2>
          <p className="section-description">
            A comprehensive toolkit of modern technologies and frameworks I use to build exceptional digital experiences
          </p>
        </div>

        {/* Skills Categories */}
        <div className="skills-categories">
          {skillCategories.map((category, index) => (
            <div key={index} className="category-card">
              <div className="category-header" style={{ '--category-color': category.color }}>
                <div className="category-icon" style={{ backgroundColor: `${category.color}20`, color: category.color }}>
                  {category.icon}
                </div>
                <h3 className="category-title">{category.title}</h3>
              </div>
              
              <div className="category-skills">
                {category.skills.map((skill, skillIndex) => (
                  <div key={skillIndex} className="skill-item">
                    <div className="skill-info">
                      <span className="skill-icon">{skill.icon}</span>
                      <span className="skill-name">{skill.name}</span>
                    </div>
                    <div className="skill-progress-wrapper">
                      <div className="skill-progress">
                        <div 
                          className="skill-progress-fill" 
                          style={{ 
                            width: `${skill.level}%`,
                            background: `linear-gradient(90deg, ${category.color}, ${category.color}cc)`
                          }}
                        />
                      </div>
                      <span className="skill-percentage">{skill.level}%</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* All Skills Tags */}
        <div className="skills-tags-section">
          <h3 className="tags-title">Technologies I Work With</h3>
          <div className="skills-tags">
            {allSkills.map((skill, index) => (
              <div key={index} className="skill-tag" data-category={skill.category}>
                {skill}
              </div>
            ))}
          </div>
        </div>

        {/* Skills Summary */}
        <div className="skills-summary">
          <div className="summary-card">
            <div className="summary-icon">
              <Zap size={32} />
            </div>
            <h4>Fast & Efficient</h4>
            <p>Building performant applications with optimized code and modern best practices</p>
          </div>
          
          <div className="summary-card">
            <div className="summary-icon">
              <Shield size={32} />
            </div>
            <h4>Robust & Scalable</h4>
            <p>Creating maintainable architectures that scale with your business needs</p>
          </div>
          
          <div className="summary-card">
            <div className="summary-icon">
              <Eye size={32} />
            </div>
            <h4>User-Focused</h4>
            <p>Prioritizing intuitive user experiences with pixel-perfect implementation</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Skills;